/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import ClassNames from 'classnames';

import Translate from '../../../Translate';

import moment from 'moment';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

class SubscriptionTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: '/images/black/no-package-poster.png'
    };
  }

  componentDidMount() {

    this.props.subscription.id && lh.models.asset.methods.getPosterUrl(this.props.subscription, {
      crop: {x: 132, y: 132},
      cache: false
    })
      .then((url) => {
        this.setState({picture: url});
      });
  }

  componentWillReceiveProps(newProps) {

    if (newProps.subscription.id !== this.props.subscription.id) {
      lh.models.asset.methods.getPosterUrl(newProps.subscription, {
        crop: {x: 132, y: 132},
        cache: false
      })
        .then((url) => {
          this.setState({picture: url});
        });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return _get(this.props, 'subscription.id') !== _get(nextProps, 'subscription.id')
      || this.state.picture !== nextState.picture
      || this.props.isSelected !== nextState.isSelected
      || !_isEqual(_get(nextProps, 'subscription', null), _get(this.props, 'subscription', null));
  }

  _renderOffer() {

    if (this.props.subscription.is_purchased) {

      let entData = moment.unix(this.props.subscription.ent.subscription_period_end);

      return (<div className="offer" style={{position: 'absolute', bottom: '22px', right: '8px', textAlign: 'end'}}>
        <strong>{_get(this.props.subscription, 'ent.subscription_cancel_at_end', false) ? <Translate content="profile.subscription.expires" /> : <Translate content="profile.subscription.subscription_period_end" />}:</strong>
        <div className="mt">{entData.format('LL')}</div>

      </div>);
    }

    var offer = this.props.subscription;

    return (
      <div className="offer" style={{position: 'absolute', bottom: '11px', right: '8px', textAlign: 'end'}}>
        <div className="offer-price color-grey pl-">
          { _get(offer, 'right_params.duration') + ' ' + _get(offer, 'right_params.duration_unit') + '(s)' }
        </div>
        <div className="offer-price profile-bigtext mt">
          <i className={`ic ic-currency-${_get(offer, 'billing_params.currency', '').toLowerCase()}`}></i>
          <span>{_get(offer, 'billing_params.price') / 100}</span>
        </div>
      </div>
    );
  }

  render() {

    let SubscriptionTileClass = ClassNames({
      'col-last': this.props['col'] === 2,
      'channel block-3 bg-black radius showcase-row-channel-block': true
    });

    let lock = '';
    if (!this.props.subscription.is_purchased && !this.props.subscription.is_available && !this.props.subscription.is_free) {

      lock = <div className="lock" style={{top: '10px', right: '10px'}}>
        <i className="ic ic-lock ic-16px"></i>
      </div>;
    }

    return (
      <div className={SubscriptionTileClass} onClick={this.props.onSubscriptionSelect.bind(this, this.props.subscription, this.props.row, this.props.col)}>
        <a className="movie-link profile-show col hover">
          {this.props.isSelected && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-14px asset-selected-icon"></i>
          </ReactCSSTransitionGroup>}
          <div className="channel-poster block-1">
            <img src={this.state.picture} alt={this.props.subscription.name} />
          </div>
          <div className="block-1 profile-descr pr-">
            <div>{this.props.subscription.name}</div>
            <div className="color-grey mt"><Translate content="profile.subscription.subscription" /></div>
          </div>
          <div className="block-1 profile-descr">
            {this._renderOffer()}
          </div>
          {lock}
        </a>
      </div>
    );
  }
}

SubscriptionTile.propTypes = {
  subscription: PropTypes.object.isRequired,
  onSubscriptionSelect: PropTypes.func.isRequired
};

export default SubscriptionTile;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Tile/Subscription/subscription-tile.js